import { Photo } from '../types';

// Array con todos los IDs de Cloudinary
export const cloudinaryImageIds = [
  "alin/ab09v19p1gbgtpnjdtom",
  "alin/aoxeszjxdnj8f0devuxr",
  "alin/avlirbt80kzoazdfh6wd",
  "alin/aylkukgkftsr3wskk6b1",
  "alin/b1ugvxnazx1zbozydhmo",
  "alin/bjqwxyggmdd0gk1ucngq",
  "alin/bm9yqbtybvd3gmkeqlxd",
  "alin/bncgzea5cgqusltw15xk",
  "alin/brhgc7xq4mdkav7f5kmo",
  "alin/bsnnw2r8ntnnstpj7heo",
  "alin/cejqkoi2gbpzsqkl0rrq",
  "alin/cikrgetkfirbfxexkqnm",
  "alin/cjpwjug6qjga7v72gzxe",
  "alin/cpagxgcb3pq1u67ys0yp",
  "alin/d14q9fl10nncbopbxlgo",
  "alin/dcjnc0h1pj5ony5nvhqv",
  "alin/dgvnskp6qmqhbu9zntn6",
  "alin/diqlez49xj5jch6otsov",
  "alin/dmvvotkoc1bwnrwmmkkt",
  "alin/dnbu8tn6qfhlhfgcdglf",
  "alin/dvxkotnnpq0erwspuadj",
  "alin/e1kpm6atbmkxptamc7tq",
  "alin/e6og41uvt5tpgiezmfrt",
  "alin/e7xdfzujb0qqsy8un83p",
  "alin/ejtvtna4kmllo8qzpl2n",
  "alin/elh0j8e5k74eisaxphpx",
  "alin/emktnqgzq0yyujkkw1zg",
  "alin/etqmmuueghp1lx5sfbmf",
  "alin/f1t6qm4jfrotlavsfsz5",
  "alin/g0h3geamcbbncprextvv",
  "alin/ga4th2u4v0zrbgu02g5a",
  "alin/gczegeqbevujn5s5ljmt",
  "alin/gd082is3ujo1nd5rkgxz",
  "alin/gfjuihb6w0p1o9clyrap",
  "alin/gkmnp0cnra21sxxahlze",
  "alin/gmia9qfridsvylyys5vp",
  "alin/gruudqdjjjinks27pllq",
  "alin/h2bg44zib9rvijf5gaw9",
  "alin/hfqsbmqhn1eyxlk0iccl",
  "alin/hkorffcabc5k0jhllrac",
  "alin/hwj5uuy0xdbk5yyy2jqv",
  "alin/ieufaei40oyt9mgeabdw",
  "alin/ifzqshrobavsysmbpyki",
  "alin/j46vvtdrslv2rkdw6s3h",
  "alin/j5biaukgzplrrplyvisq",
  "alin/janm6eypqwdj7drwoqbv",
  "alin/jqjb8etn7bmsaytu1rkp",
  "alin/jytudtamk2xuwrhli3og",
  "alin/kgapmdqevs15lqjtwti4",
  "alin/kpxxqyxmzribcli7i2ww",
  "alin/krt8qwuc2lpxb3fisjho",
  "alin/l1h6twhsrrmhqrls3ntj",
  "alin/l33bsu2qtsjczrj7aujj",
  "alin/l3wrkbqryk8guupvtxlx",
  "alin/lcr44vhmctvi8pvzmcpu",
  "alin/libh98yv4b9th74nbow4",
  "alin/lmuykdzdyuawopppjp7d",
  "alin/lniirayatmd9ndh3mgyk",
  "alin/ls0luewhuzjvumgriwsj",
  "alin/lyhapbiaui9ufgvqynrp",
  "alin/mcr3myzspbvjhnvb873n",
  "alin/mmxkjm1rwb3ta7ycwc2m",
  "alin/mywggum99aucfy3h7tut",
  "alin/n2dyc0ez7l0xyyhuracp",
  "alin/n9jvoz9pe8hrpq7r0olm",
  "alin/ncqqexiyklbaubtr66ki",
  "alin/nf6iv6l49db36ptnz40m",
  "alin/niblbfxmuwkkudbvpzwg",
  "alin/nimwbyd83kuwczcxfqxd",
  "alin/npvobnnawlejgtndqslm",
  "alin/nw1v3l8zxqzkbt0e279u",
  "alin/o7kupl510kpslbpoxmsh",
  "alin/o9kczkb3f4bzhh0w0iak",
  "alin/ov1qk5ebowaumjkvicpd",
  "alin/ozakbb5s8lidvultudyh",
  "alin/pelbkyqqb4rer3zswm8n",
  "alin/pj1sx1fzjve7m0sb5r8h",
  "alin/pr40dlngoejphyathjky",
  "alin/psurwwh0pkiy6mezpkfp",
  "alin/pukpqlcygufqeestg26j",
  "alin/px3o81xb7dn6e0nhauou",
  "alin/q2rxlimxobtytnmqywsz",
  "alin/q8j6ellpo3lmi7ihjkyg",
  "alin/qfbps7ijwh5u0frtncpy",
  "alin/qntsl9hme8cx2fdrqgqb",
  "alin/qqybhmxexhjjyf2cxul5",
  "alin/quyqdir1ep0bi3ewwms3",
  "alin/qy7aalwdwub909xbvzae",
  "alin/qybemocynu7d7atacxz8",
  "alin/rat486avj2k7uuercxcq",
  "alin/rc9g0q3rfllelkrtlpzb",
  "alin/rgnjsfr07eidr7d5fd8d",
  "alin/s7divqcgex8p0ydybpbe",
  "alin/sbdfzi9axxucrh5raa1x",
  "alin/smbhusak0bpcfidln3ye",
  "alin/smo3ejb57wbmzgenlwnc",
  "alin/sqznricsre44rfuetuic",
  "alin/t341ylwdyhp3qajen9pq",
  "alin/t9mu5gsx9nlkmzobw1gv",
  "alin/tacfuuq6vaouot1jnsq5",
  "alin/tcsp3lo1r4uwoxnfdurk",
  "alin/ts8stfp5hjpxbkpxbbox",
  "alin/tssnumgqqb1dvxkrwt6x",
  "alin/tx3ys4c2ekzpucyzvsko",
  "alin/uc7uaqulihatrnmyhtvk",
  "alin/udzqrrxsdurixvmrruig",
  "alin/ufjxynoggrzjtqfs1xxi",
  "alin/ujul1pcwonrsbc2cyqyt",
  "alin/ulcl297qdxyidf04ucjz",
  "alin/urolbtoxznapwnocg4lt",
  "alin/ut1fjm7rrbgn0omza1uo",
  "alin/vhheh0vtziv1ebhrh05w",
  "alin/vkx54vqve6ua47tmxz5h",
  "alin/vxrloaxhd7xhupyldjjc",
  "alin/vydxeuky0bpwohg1wf2s",
  "alin/vzsbgtl7xiimr4ktamok",
  "alin/wdwp1xagy6jfkkte3gge",
  "alin/wv7v14jb6obv9kzyhw6n",
  "alin/wxpdk4khtnni2pxdb332",
  "alin/x2v4hceulolf8zmtgnks",
  "alin/x6ev0rhtuzofpddabl1a",
  "alin/xg3kqsrdcgdlkzmoyc1e",
  "alin/xi1di8vnkxnol101hi5w",
  "alin/xu8sauvryygcoieck66h",
  "alin/y6ncuw1thfons6da7aay",
  "alin/y7neu6izcb2m4cphkv0j",
  "alin/ybsquzda4r1fxxas8eb3",
  "alin/yeeofgz95fldrdy1ptr9",
  "alin/yo23rqfeut4en1ubxrjz",
  "alin/yq9n6o08ntd7dcgipxwd",
  "alin/yvdg4i6iq9pbwzv8q3c8",
  "alin/zb3oo2r2fevmttr615mc",
  "alin/zhrtftu5lrrqaitvsymf",
  "alin/zwnzho7pvliinqw7tasb",
  "alin/zxhz58lrnrzeddpz2x7u"
];

// Genera datos de fotos utilizando todos los IDs
export const allPhotos: Photo[] = cloudinaryImageIds.map((id, index) => ({
  id: (index + 1).toString(),
  src: id,
  alt: `Alin Photo ${index + 1}`,
  width: 1200, // Dimensiones predeterminadas
  height: 800, // Puedes actualizarlas más tarde
  caption: `Recuerdo #${index + 1}`,
  date: `${Math.floor(2008 + index * 0.1).toString()}-${(index % 12 + 1).toString().padStart(2, '0')}-${(index % 28 + 1).toString().padStart(2, '0')}`,
  tags: index % 3 === 0 ? ['familia', 'especial'] :
        index % 3 === 1 ? ['amigos', 'diversión'] : ['aventura', 'momentos']
}));

// Lista de imágenes destacadas para mostrar primero
export const featuredPhotos: Photo[] = [
  // Utilizando tus IDs específicos mencionados en el código original
  allPhotos.find(photo => photo.src === "alin/lyhapbiaui9ufgvqynrp") || allPhotos[0],
  allPhotos.find(photo => photo.src === "alin/l1h6twhsrrmhqrls3ntj") || allPhotos[1],
  allPhotos.find(photo => photo.src === "alin/xu8sauvryygcoieck66h") || allPhotos[2],
  allPhotos.find(photo => photo.src === "alin/qntsl9hme8cx2fdrqgqb") || allPhotos[3],
  allPhotos.find(photo => photo.src === "alin/mcr3myzspbvjhnvb873n") || allPhotos[4],
  allPhotos.find(photo => photo.src === "alin/dgvnskp6qmqhbu9zntn6") || allPhotos[5],
  allPhotos.find(photo => photo.src === "alin/ulcl297qdxyidf04ucjz") || allPhotos[6],
  allPhotos.find(photo => photo.src === "alin/hkorffcabc5k0jhllrac") || allPhotos[7]
].filter((photo): photo is Photo => photo !== undefined);


// Mensaje personal
export const personalMessage = {
  message: `Querida Alín, ver cómo has crecido y te has convertido en esta hermosa jovencita me llena de orgullo. Cada momento a tu lado ha sido especial y quiero que sepas que siempre estaré aquí para apoyarte y celebrar tus logros. ¡Felices 15 años! Que este nuevo capítulo de tu vida esté lleno de sueños cumplidos y nuevas aventuras.`,
  author: 'Con todo mi cariño'
};

